// extracted by mini-css-extract-plugin
export default {"primary-text":"si-service-detail_primary-text__of+F1","info-section-title":"si-service-detail_info-section-title__cb-DT"};